<script setup>
defineProps({
  iconStyle: {
    type: String,
    required: false,
    default: 'plusMin',
    validator: (value) => ['plusMin', 'arrow'].includes(value),
  },
})

const isOpen = ref(false)

function toggleAccordion() {
  isOpen.value = !isOpen.value
}
</script>
<template>
  <div>
    <button
      class="flex w-full items-center justify-between p-6 text-gray-900"
      :aria-expanded="isOpen"
      :aria-controls="`collapse`"
      @click="toggleAccordion"
    >
      <slot name="title" />
      <div v-if="iconStyle === 'plusMin'" class="">
        <IconPlus v-if="!isOpen" class="w-3" />
        <IconMinus v-if="isOpen" class="w-3" />
      </div>
      <div v-if="iconStyle === 'arrow'" class="">
        <IconChevronDown v-if="!isOpen" class="w-[10px]" />
        <IconChevronUp v-if="isOpen" class="w-[10px]" />
      </div>
    </button>
    <div v-show="isOpen" :id="`collapse`" class="px-6 pb-6">
      <slot name="content" />
    </div>
  </div>
</template>
